import isNull from "lodash/isNull";
import { bugNotif } from "../../api/bugsnag";
import { getSubscription } from "../subscription";
import { getErrorMsg } from "../../../Common/utils/common";
import { generateFbqEventId } from "../../../Common/services/marketing/facebook";

export {
  sendFbqInitiateCheckout,
  sendFbqLead,
  sendFbqAddPaymentInfo,
  sendFbqCompleteRegistration,
} from "../../../Common/services/marketing/facebook";

declare const fbq: (
  action: string,
  event: string,
  data: Record<string, unknown>,
  options?: { eventID?: string }
) => void;

export const sendFBTracking = async (
  type: "Membership" | "One Off" | "Power Up",
  pid: string,
  value: number
) => {
  try {
    const subscription = await getSubscription(pid);
    if (!isNull(subscription)) {
      fbq(
        "track",
        "Purchase",
        {
          content_name: subscription.name,
          content_category: type,
          content_type: "product",
          content_ids: [subscription.docId],
          value: value,
          currency: "AUD",
          subscription_tier: subscription.name,
          predicted_ltv: value * 12,
        },
        { eventID: generateFbqEventId() }
      );
    }
  } catch (error) {
    console.log("error sendFBTracking", error);
    bugNotif("sendFBTracking", getErrorMsg(error).rawErrorMsg);
  }
};

export const sendFbqCart = async (
  type: "Membership" | "One Off" | "Power Up",
  pid: string,
  value: number
) => {
  try {
    const subscription = await getSubscription(pid);
    if (!isNull(subscription)) {
      fbq(
        "track",
        "AddToCart",
        {
          content_name: subscription.name,
          content_category: type,
          content_type: "product",
          content_ids: [subscription.docId],
          value: value,
          currency: "AUD",
        },
        { eventID: generateFbqEventId() }
      );
    }
  } catch (error) {
    console.log("error sendFbqCart", error);
    bugNotif("sendFbqCart", getErrorMsg(error).rawErrorMsg);
  }
};

